module.exports = __webpack_public_path__ + "img/b3-3.0963232.png";